import { XCircle } from 'lucide-react';
import '../shared/offer-bar.css';
import './OfferNotice.css';

interface OfferNoticeProps {
  /** Message to show, or null to hide. Timing is owned by the parent. */
  message: string | null;
}

/**
 * Esito negativo di una proposta fatta all'avversario ("ha rifiutato la patta"),
 * come pastiglia ancorata SOPRA la barra di gioco.
 *
 * Prima non c'era niente: il rifiuto azzerava dei flag e basta, e l'unica cosa
 * che cambiava sullo schermo era il bottone che tornava disponibile — che nessuno
 * legge come una risposta. Sta qui e non sulla damiera perche' la barra e' l'unico
 * punto che tutte e tre le schermate online (partita, arena, torneo) hanno in
 * comune, ed e' anche dove si guardava un attimo prima, avendo appena premuto.
 *
 * La pastiglia in se' e' `.offer-chip`, condivisa con l'esito della rivincita a
 * fine partita: e' la stessa notizia, e deve avere la stessa faccia.
 *
 * Puramente presentazionale, come TakebackNotice: il padre decide quale messaggio
 * e' attivo e quando sparisce.
 */
export default function OfferNotice({ message }: OfferNoticeProps) {
  if (!message) return null;
  return (
    <div className="offer-chip offer-notice" role="status" aria-live="polite" data-testid="offer-notice">
      <XCircle size={16} aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
